import React, { useState, useEffect, createContext, useCallback, useContext, useRef } from 'react';
import { NavType } from '@/types';
import { useRouter } from 'next/router';
import axios from 'axios';
import Head from 'next/head';
import useRequest from '@/utils/useRequest';

interface IndexContextProps {
  nav?: NavType[];
  isHeadFoot: boolean;
  webInfo: any;
  isBecome?: Boolean;
  setIsHeadFoot: (isHeadFoot: boolean) => void;
  setIsBecome: (isBecome: boolean) => void;
  getNav: (lang: string) => void;
}

interface IProps {
  children: JSX.Element;
}


export const IndexContext = createContext<IndexContextProps>({} as IndexContextProps);

export const IndexContextProvider = ({ children }: IProps): JSX.Element => {
  const [nav, setNav] = useState<NavType[]>();
  const [isHeadFoot, setIsHeadFoot] = useState<boolean>(true)
  const [isBecome, setIsBecome] = useState<boolean>(false)
  const [webInfo, setWebInfo] = useState()
  const [lang, setLang] = useState<'cn' | 'en'>('cn')
  const router = useRouter()
  const request = useRequest()

  const transTree = useCallback((root: any) => {
    if (!root.length)
      return [];

    return root.map((item: any) => {
      const { id, title, path, pid, childlist, ...arg } = item
      return {
        ...arg,
        id,
        name: title,
        path,
        parent: pid,
        children: [...transTree(childlist)]
      }
    })

  }, [router])

  const getNav = useCallback(async (lang: string) => {
    const { data } = await request.get('/getHomeMenuList', {
      headers: {
        lang
      }
    })
    setNav(transTree(data.data))
  }, [request, router])

  const getWebInfo = useCallback(async () => {
    const { data } = await request.get('/getWebInfo')
    setWebInfo(data.data)
  }, [])

  useEffect(() => {
    getNav(router.locale || 'cn')
    getWebInfo()
  }, [])


  return (
    <IndexContext.Provider
      value={{
        nav,
        webInfo,
        isBecome,
        isHeadFoot,
        getNav: (lang: string): void => {
          getNav(lang)
        },
        setIsHeadFoot: (_isHeadFoot: boolean): void => {
          setIsHeadFoot(_isHeadFoot)
        },
        setIsBecome: (_isBecome: boolean): void => {
          setIsBecome(_isBecome)
        },
      }}
    >
      {children}
    </IndexContext.Provider>
  );
};

